import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.define-property";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { createClient as createCoreStructuredContentClient } from '@nerdwallet/structured-content-core';
import nerdwalletSchema from './schema';
import nerdwalletComponents from './components';
import createNerdwalletProviders from './create-providers';
export default function createClient() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      nwApiSdk = _ref.nwApiSdk,
      appConfig = _ref.appConfig,
      serverRequest = _ref.serverRequest,
      apolloClient = _ref.apolloClient,
      _ref$createProviders = _ref.createProviders,
      createProviders = _ref$createProviders === void 0 ? createNerdwalletProviders : _ref$createProviders,
      _ref$components = _ref.components,
      components = _ref$components === void 0 ? nerdwalletComponents : _ref$components,
      _ref$schema = _ref.schema,
      schema = _ref$schema === void 0 ? nerdwalletSchema : _ref$schema,
      isomorphicState = _ref.isomorphicState,
      dataProviders = _ref.dataProviders;

  var providers = createProviders({
    serverRequest: serverRequest,
    apolloClient: apolloClient,
    schema: schema,
    nwApiSdk: nwApiSdk,
    appConfig: appConfig
  });
  return _objectSpread(_objectSpread({}, createCoreStructuredContentClient({
    schema: schema,
    components: components,
    providers: providers,
    isomorphicState: isomorphicState,
    dataProviders: dataProviders
  })), {}, {
    serverRequest: serverRequest
  });
}